// English translations
export const en = {
  // Header
  header: {
    title: 'MicroGPT Lab',
    subtitle: 'Learn microgpt interactively',
    level: 'Lv.',
    params: 'params',
    badges: 'badges',
    train: 'Train',
    star: 'Star'
  },

  // Navigation
  nav: {
    curriculum: 'Curriculum',
    content: 'Content',
    visualization: 'Visualization'
  },

  // Levels
  levels: {
    completed: 'Completed',
    locked: 'Locked',
    current: 'Current Level'
  },

  // Buttons
  buttons: {
    complete: 'Complete Level',
    startLearning: 'Start Learning',
    trainAgain: 'Train Again',
    reset: 'Reset',
    close: 'Close',
    cancel: 'Cancel',
    confirm: 'OK',
    showHint: 'Show Hint',
    showSolution: 'Show Solution',
    runCheck: 'Run & Check',
    randomize: 'Randomize'
  },

  // Training Experience
  training: {
    title: 'Train MicroGPT',
    intro: 'Watch a language model train and generate text in real-time',
    starting: 'Starting training...',
    training: 'Training...',
    generating: 'Generating samples...',
    complete: 'Training Complete!',
    lossLabel: 'Loss',
    stepLabel: 'Step',
    generatedNames: 'Generated Names (Hallucinated!)',
    explanation: 'These names were hallucinated by the model - it\'s never seen them before!',
    pipeline: 'The Complete MicroGPT Pipeline',
    comparison: 'From This Demo to ChatGPT',
    thisDemo: 'This Demo',
    chatgpt: 'ChatGPT',
    sameAlgorithm: 'Same algorithm, different scale!'
  },

  // About Dialog
  about: {
    title: 'About MicroGPT',
    subtitle: 'The essence of large language models',
    whatIs: 'What is MicroGPT?',
    whatIsDesc: 'MicroGPT is a minimal implementation of a GPT-style language model...',
    whatYoullLearn: 'What You\'ll Learn',
    fromMicroToMega: 'From Micro to Mega',
    chatgptConnection: 'The ChatGPT Connection',
    resources: 'Resources',
    resetProgress: 'Reset All Progress',
    resetProgressDesc: 'Clear all completed levels and earned badges',
    resetConfirm: 'Are you sure you want to reset all progress? This will clear completed levels and earned badges.'
  },

  // Code Exercise
  exercise: {
    description: 'Description',
    template: 'Code Template',
    hint: 'Hint',
    solution: 'Solution',
    useSolution: 'Use this solution',
    attempts: 'attempt',
    attemptsPlural: 'attempts',
    checking: 'Checking...',
    loading: 'Loading Python environment...',
    testPassed: 'Test passed',
    testFailed: 'Test failed',
    allTestsPassed: 'All tests passed!',
    someTestsFailed: 'Some tests failed',
    tabSpaces: 'Tab = 4 spaces'
  },

  // Notifications
  notifications: {
    badgeEarned: 'Badge earned',
    levelComplete: 'Level complete!',
    readyToLearn: 'Ready to learn how it works!'
  },

  // Theme
  theme: {
    chooseTheme: 'Choose Theme',
    selectScheme: 'Select your preferred color scheme',
    dark: 'Dark',
    light: 'Light'
  },

  // Common
  common: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Info'
  }
};
